import { render, staticRenderFns } from "./FooterHolder.vue?vue&type=template&id=a51644de&"
import script from "./FooterHolder.vue?vue&type=script&lang=js&"
export * from "./FooterHolder.vue?vue&type=script&lang=js&"
import style0 from "./FooterHolder.vue?vue&type=style&index=0&id=a51644de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports